/**
 *
 * Form the array of filter pairs where filters' values are stored as { label, value } objects
 * and the last element of the array is the header of the filter
 *
 * @param {Object} filterHeaders
 * @param {Array} sources
 * @param {Object} curConfig
 * @returns an array containing filter pairs and the filter header
 */
export const formFilterPairs = (filterHeaders, sources, curConfig) => {
  const filterPairs = {}

  // if curConfig is empty (general add button clicked), build configuration from all sources,
  // else build configuration from only curConfig (add part clicked)
  const buildFilterSources = Object.keys(curConfig).length > 0 ? [curConfig] : sources

  for (const filter in filterHeaders) {
    if (!filterHeaders.hasOwnProperty(filter)) continue

    const valueSet = new Set()

    buildFilterSources.forEach(source => {
      // add filter values to Set and use Set to eliminate duplicate values
      valueSet.add(String(source[filter]))
    })

    // build array of { label, value } objects
    const valuePairs = Array.from(valueSet).map(value => {
      return {label: value, value}
    })
    // push the filter header to the end of the array
    valuePairs.push(filterHeaders[filter])
    filterPairs[filter] = valuePairs
  }

  return filterPairs
}
